<script>
export default {
    name: "HeadCountSessionReport",

    data() {

        return {
            headCountSessions: [],
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.all([this.fetchHeadCountHistory(),]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 300);
        }).catch(() => {this.$root.loading=false;});
    },

    methods: {

        fetchHeadCountHistory() {
            let url=`HeadCountSurveilance/GetHeadCount`;
                url+=`?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;

            return this.$http.get(url).then(({data}) => {
                    this.headCountSessions=data;
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full p-2">
            <h5 class="text-lg">Head Count Sessions</h5>
        </div>
        <div class="w-full overflow-visible mt-2">
            <table class="table text-xs">
                <thead class="bg-blue-500 text-white">
                    <tr>
                        <th class="p-tiny">Code</th>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">No Present</th>
                        <th class="p-tiny">Absent</th>
                        <th class="p-tiny">Total</th>
                        <th class="p-tiny">Comment</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="headCountSession in headCountSessions" :key="headCountSession.headCountID">
                        <td class="p-tiny">{{headCountSession.headCountID}}</td>
                        <td class="p-tiny">{{headCountSession.sysDate | dateFormatDT}}</td>
                        <td class="p-tiny">{{headCountSession.noofPatientsPresent}}</td>
                        <td class="p-tiny " :class="{
                            'bg-red-300' : headCountSession.noofPatientsAbsent,
                        }">{{headCountSession.noofPatientsAbsent}}</td>
                        <td class="p-tiny">{{headCountSession.totalNoofPatients}}</td>
                        <td class="p-tiny w-40 break-words">{{headCountSession.comment || `-`}}</td>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
</template>